import StepType from "./step.type";

export default class ShipmentStepModel extends StepType {}
